import {
  ToastPosition,
  useToasts,
} from '@terminal/stores/use-toasts/useToasts';
import {
  ConnectionToast,
  ConnectionToastAction,
  TOAST_ID,
} from '@terminal/views/alfred/research/connection-toast/ConnectionToast';
import { useTranslation } from 'react-i18next';

export interface ShowConnectionToastArgs {
  action?: ConnectionToastAction;
  serviceName: string;
  status: 'success' | 'error';
  deleteConversations?: boolean;
  message?: string;
}

export const useConnectionToast = () => {
  const { t } = useTranslation(['chat']);
  const { showToast } = useToasts();

  return ({
    action = 'connect',
    serviceName,
    status,
    deleteConversations,
    message,
  }: ShowConnectionToastArgs) => {
    showToast({
      id: TOAST_ID,
      hideToast: true,
      position: ToastPosition.TopRight,
      content: (
        <ConnectionToast
          action={action}
          name={t(`chat:services.${serviceName}.name`)}
          status={status}
          removeConversation={deleteConversations}
          message={message}
        />
      ),
    });
  };
};
